@if (loading) {
    <spinner-overlay [fullscreen]="true"></spinner-overlay>
}

<div [ngClass]="project?'project-container':'organisation-container'">
        @if (linqset && organisation) {
            <app-menu [organisation]="organisation" [linqset]="linqset" [project]="project" [screen]="screen" [helpGuides]="helpGuides" (modelFilterEvent)="handleModelFilterEvent($event)" (menuEvent)="handleFunctionEvent($event)" (selectNodeEvent)="handleSelectNodeEvent($event)"></app-menu>
        }

        @if (linqset && organisation) {
            @if (project) {
                <div class="project-banner" role="status" data-testid="project-banner">
                    <mat-icon>construction</mat-icon>
                    <span>You are working in the project <b>{{project.name}}</b>. Changes here do not affect current state until the project is merged.</span>
                </div>
            }
            <mat-card appearance="raised" class="page-header" data-testid="home-header">
                <div class="page-header-top">
                    <div class="page-title">
                        <h2>{{organisation.name}}</h2>
                        <span class="workspace-chip" [class.project]="project" [matTooltip]="project?'Project ' + workspaceName + ': a future state being built from current state':'The current state of the organisation'">
                            <mat-icon>{{project?'construction':'business'}}</mat-icon><span class="truncated-name">{{project?'Project: ' + workspaceName:workspaceName}}</span>
                        </span>
                    </div>
                    @if (!app.smallScreen) {
                        <div class="header-actions">
                            @if (!project && hasAdminAccess()) {
                                <button mat-button matTooltip="Edit organisation details" color="accent" (click)="executeFunction(FUNCTION.EDIT_ORGANISATION)">Edit organisation</button>
                            }
                            @if (project && hasWriteAccess()) {
                                <button mat-button matTooltip="Describe a change, such as adding people to a role or replacing a system, and AI makes it in this project" color="accent" (click)="changeWithAI()" data-testid="change-with-ai"><mat-icon>auto_awesome</mat-icon>Change with AI</button>
                            }
                            @if (project && hasAdminAccess()) {
                                <button mat-button matTooltip="Edit the current project" color="accent" (click)="updateProjectDetails()">Edit project</button>
                                <button mat-button matTooltip="Merges all model changes into current state" color="accent" (click)="confirmMergeDialog()">Merge into current state</button>
                            }
                            <button mat-button matTooltip="Open view of organisation model" color="accent" (click)="openOrganisationModel()">Organisation model</button>
                            <button mat-button matTooltip="Open view of people and systems" color="accent" (click)="openPeopleSystemsModel()">People and systems</button>
                        </div>
                    }
                </div>
                @if (headlines.length > 0) {
                    <div class="headlines">
                        @for (h of headlines; track h.label) {
                            <div class="headline" [matTooltip]="h.tooltip">
                                <div class="headline-value" [class.warn]="h.warn" [appFitText]="h.value" [fitTextShort]="h.short"></div>
                                <div class="headline-label">{{h.label}}</div>
                                @if (h.change) {
                                    <div class="headline-vs">@if (h.before) {<span>Current state {{h.before}}</span>}<span [class]="'headline-change ' + h.change.tone">{{h.change.text}}</span></div>
                                }
                            </div>
                        }
                    </div>
                    @if (comparison) {
                        <div class="headline-note">Each figure is compared with the current state: green is an improvement, red a decline.</div>
                    }
                }
            </mat-card>
            @if (!project && !app.smallScreen) {
                <app-getting-started-checklist [organisation]="organisation" [users]="organisationService.users?.length" (invite)="inviteUser()"></app-getting-started-checklist>
            }
        }

        <div class="flex-container">
    @if (organisation && linqset) {
            <div class="flex-item-single">
                <app-overview-card [organisation]="organisation" [workspaceKey]="projectKey || 'current-state'" [trigger]="linqset"></app-overview-card>
            </div>
    }
    @if (organisation) {
            <div class="flex-item-single">
            <mat-card appearance="raised" data-testid="home-card">
            <div class="controls-container">
                <h3>Models</h3>
                <mat-card-actions>
                @if (hasWriteAccess() && !app.smallScreen) {
                    <button mat-button matTooltip="Create a new model" color="accent" (click)="executeFunction(FUNCTION.CREATE_MODEL)">Create model</button>
                }
                </mat-card-actions>
            </div>
            <mat-card-content>
                @if (isHelpOn() && !app.smallScreen) {
                <div class="hint">List of {{project?'project':'current state'}} models. {{project?'Red model icons show that the model has been changed in the project.':''}} Click a row to view the model. Click the edit icon to edit the model details. Click the rubbish bin to delete a model. Click the eye icon to view inline insights for the model. You can filter the list by typing in the input box below this message.</div>
                }
                <app-model-table [organisation]="organisation" [organisationLinqset]="linqset" [project]="project" [compact]="app.smallScreen"></app-model-table>
            </mat-card-content>
            </mat-card>
        </div>
    }
            @if (linqset) {
                <div class="flex-item map-item">
                    <mat-card appearance="raised" data-testid="home-card">
                        <div class="controls-container">
                            <h3>Model map</h3>
                            <mat-card-actions>
                                <button mat-button color="accent" matTooltip="Step through a model, then see it simulated, as a heatmap and as an EPM report" (click)="openModelWalkthrough()" data-testid="home-model-walkthrough"><mat-icon>tour</mat-icon>Model walkthrough</button>
                            </mat-card-actions>
                        </div>
                        @if (isHelpOn()) {
                        <div class="hint">Information from one model can be passed as input to other models. This shows those relationships. Double click on a model icon to view that model. Click the diagram, then use the mouse wheel to zoom in and out. Hold Alt and left mouse button down to drag the display.</div>
                        }

                        <div [ngClass]="app.smallScreen?'graph-container-small':'graph-container'">
                            <app-graph-component [linqset]="linqset" [modelType]="modelType" [readOnly]="true" [focusToInteract]="true" (itemDoubleClickedEvent)="graphItemDoubleClickHandler($event)"></app-graph-component>
                        </div>
                    </mat-card>
                </div>
                <div class="flex-item">
                    <mat-card appearance="raised" data-testid="home-card">
                        <div class="controls-container">
                            <h3>Insights</h3>
                            <mat-card-actions>
                                <button mat-button matTooltip="View carousel of insights" color="accent" (click)="openCarousel()">View carousel</button>
                            </mat-card-actions>
                        </div>
                        <mat-card-content>
                            @if (isHelpOn()) {
                                <div class="hint">Provides a summary of the {{project?"project":"organisation's current state"}}. This represents the total of all the model insights in the organisation.</div>
                            }
                            <app-insights-overview [summary]="true" [hideZeroCards]="true" [linqset]="linqset" [comparison]="comparison"></app-insights-overview>
                        </mat-card-content>
                    </mat-card>
                </div>
            }
    @if (!app.smallScreen && organisation) {
        <div class="flex-item">
            <mat-card appearance="raised" data-testid="home-card">
            <div class="controls-container">
                <h3>Information assets</h3>
            </div>
            <mat-card-content>
                @if (isHelpOn()) {
                <div class="hint">The organisation's information assets: each is the information itself, such as a customer order, and the information nodes linked to it in the models are its states. Each shows its register (owner, classification and system of record) and its figures across its states, including the value LINQ derives from how it is used. Add an asset, or use the pencil to change one and its register. Click on an asset to see the models it is in.</div>
                }
                <app-information-asset-table [linqset]="linqset" [projectKey]="projectKey"></app-information-asset-table>
            </mat-card-content>
            </mat-card>
        </div>
        @if (!project) {
            <div class="flex-item">
            <mat-card appearance="raised" data-testid="home-card">
                <div class="controls-container">
                    <h3>Organisation settings</h3>
                </div>
                <mat-tab-group mat-stretch-tabs="false" animationDuration="0ms" data-testid="settings-tabs">
                    <mat-tab [label]="'Users (' + (organisationService.users?.length || 0) + ')'">
                        <div class="tab-actions">
                            @if (hasAdminAccess()) {
                                <button mat-button matTooltip="Invite a user to join the organisation" (click)="inviteUser()" color="accent"><mat-icon>person_add</mat-icon>Invite user</button>
                            }
                        </div>
                        @if (isHelpOn()) {
                            <div class="hint">List of users that have access to this organisation. Organisation admins can change a user's role by clicking it, resend a pending invite, or remove a user. Use Invite user to add someone new.</div>
                        }
                        <app-organisation-users [organisation]="organisation" [users]="organisationService.users"></app-organisation-users>
                    </mat-tab>
                    <mat-tab [label]="'Backups (' + backupCount() + ')'">
                        <div class="tab-actions">
                            @if (hasAdminAccess()) {
                                <button mat-button [matTooltip]="organisation.backup ? 'Replace the organisation backup with a new one of all model data' : 'Back up all model data for the organisation'" (click)="createOrganisationBackup()" color="accent"><mat-icon>backup</mat-icon>{{organisation.backup ? 'Replace organisation backup' : 'Create organisation backup'}}</button>
                                <button mat-button matTooltip="Replace all model data with the organisation backup" (click)="restoreOrganisationBackup()" color="accent" [disabled]="!organisation.backup"><mat-icon>restore</mat-icon>Restore organisation backup</button>
                                <button mat-button matTooltip="Delete every model backup. The organisation backup is kept. Cannot be undone." (click)="deleteAllBackups()" color="warn" class="destructive-action" [disabled]="!modelBackupCount()"><mat-icon>delete_forever</mat-icon>Delete all model backups</button>
                            }
                            @if (isSysAdmin()) {
                                <!-- LINQ administrators only: the whole organisation as a file, to import elsewhere -->
                                <button mat-button matTooltip="Download the organisation and all its models as a JSON file, to import as a new organisation or into an empty one" (click)="exportOrganisation()" color="accent" data-testid="export-organisation"><mat-icon>file_download</mat-icon>Export organisation</button>
                                <button mat-button [matTooltip]="isEmpty() ? 'Fill this organisation from an organisation export file' : 'Only an organisation with no models or projects can be imported into'" (click)="importIntoOrganisation()" color="accent" [disabled]="!isEmpty()" data-testid="import-into-organisation"><mat-icon>upload_file</mat-icon>Import into this organisation</button>
                            }
                        </div>
                        @if (isHelpOn()) {
                            <div class="hint">The organisation backup is a copy of every model, and there is only one at a time. Model backups are copies of a single model, created from the model toolbar when editing it. Admins can restore or delete backups from the table.</div>
                        }
                        <app-backups-table [organisation]="organisation" (deleteBackupEvent)="loadOrganisationData()" (restoreOrganisationBackupEvent)="restoreOrganisationBackup()"></app-backups-table>
                    </mat-tab>
                    <mat-tab [label]="'Emission factors (' + (organisation.emissionFactors?.length || 0) + ')'">
                        <div class="tab-actions">
                            @if (hasAdminAccess()) {
                                <button mat-button matTooltip="Create an emission factor for an activity" (click)="executeFunction(FUNCTION.MAINTAIN_EMISSION_FACTOR)" color="accent"><mat-icon>add</mat-icon>Create emission factor</button>
                            }
                        </div>
                        @if (isHelpOn()) {
                            <div class="hint">List of emission factors for the organisation. An emission factor describes the rate at which a given activity releases greenhouse gases (GHGs) into the atmosphere. These are used with infrastructure nodes to assign emissions to model activities.</div>
                        }
                        <app-emission-factors [organisation]="organisation"></app-emission-factors>
                    </mat-tab>
                </mat-tab-group>
            </mat-card>
            </div>
            <div class="flex-item" [class.compact]="!organisation.projects?.length">
            <mat-card appearance="raised" data-testid="home-card">
                <div class="controls-container">
                <h3>Projects</h3>
                <mat-card-actions>
                    @if (hasWriteAccess()) {
                    <button mat-button matTooltip="Create a change project for the organisation" (click)="executeFunction(FUNCTION.CREATE_PROJECT)" color="accent" >Create project</button>
                    }
                </mat-card-actions>
                </div>
                <mat-card-content>
                @if (isHelpOn()) {
                    <div class="hint">List of organisation projects. Projects are used to build a future state for the organisation, by changing models from current state. Clicking on a row will go to the dashboard for that project. Click the edit icon to edit the project details. Click the rubbish bin to delete the project.</div>
                }
                <app-project-table [organisation]="organisation"></app-project-table>
                </mat-card-content>
            </mat-card>
            </div>
        }
        <div class="flex-item" [class.compact]="!todoCount">
            <mat-card appearance="raised" data-testid="home-card">
            <div class="controls-container">
                <h3>Todo list</h3>
            </div>
            <mat-card-content>
                @if (isHelpOn()) {
                <div class="hint">List of things to do. These can be attached to nodes in models to provide a reminder of areas that might need further work or analysis. Clicking on an row will take you to that item in the model.</div>
                }
                <app-todo-list [organisation]="organisation" (countChanged)="todoCount = $event"></app-todo-list>
            </mat-card-content>
            </mat-card>
        </div>
        <div class="flex-item" [class.compact]="!ticketCount">
            <mat-card appearance="raised" data-testid="home-card">
            <div class="controls-container">
                <h3>Support tickets</h3>
                <mat-card-actions>
                <button mat-button matTooltip="Create a new support ticket" color="accent" (click)="executeFunction(FUNCTION.CREATE_TICKET)">Create support ticket</button>
                </mat-card-actions>
            </div>
            <mat-card-content>
                <app-ticket-list (countChanged)="ticketCount = $event"></app-ticket-list>
            </mat-card-content>
            </mat-card>
        </div>
        }
    </div>
</div>